module.exports = __webpack_public_path__ + "static/media/23.87c25c69.png";